import { render, staticRenderFns } from "./DialogServiceFeedback.vue?vue&type=template&id=14c563b2&scoped=true"
import script from "./DialogServiceFeedback.vue?vue&type=script&lang=js"
export * from "./DialogServiceFeedback.vue?vue&type=script&lang=js"
import style0 from "./DialogServiceFeedback.vue?vue&type=style&index=0&id=14c563b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c563b2",
  null
  
)

export default component.exports